export default {
  install(Vue){
    Vue.filter('htmlFiles', (v)=> {
      if (!v) return "";
      if (dsf.isString(v)) {
        try {
          v = JSON.parse(v);
        } catch (e) {
          return "";
        }
      }
      if (dsf.isObject(v)) {
        v = [v];
      }
      let files = v.map(item => createFiles(item));
      return `<div class="proxy-files" >
        ${files.join('<i class="splitter">、</i>')}
      </div>`;
    })
  }
}

function createFiles({relativePath, suffix, originalFileName}) {
  let url = dsf.url.getWebPath(relativePath);
  return `<a class="proxy-file" href="${url}" target="_blank" onclick="event.stopPropagation()">
      <i class="dsf-file-icon ${suffix}"></i>
      <span class="name">${originalFileName}</span>
  </a>`
}